export const search_list = [
  {
    type: 'input',
    label: '课程名称',
    props: 'title',
  },
  {
      type: 'input',
      label: '讲师名称',
      props: 'teacher',
  }
]

  export const tableColumns =  [
    {
      title: '课程名称',
      value: 'title',
      header_align: 'center',
      align: 'center',
    },
    {
        title: '讲师名称',
        value: 'teacher',
        header_align: 'center',
        align: 'center',
    },
    {
      title: '课程时间',
      value: 'course_time_text',
      header_align: 'center',
      align: 'center',
    },
    {
      title: '课程状态',
      value: 'status_text',
      header_align: 'center',
      align: 'center',
    },
    {
        title: '报名人数',
        value: 'joinNum',
        header_align: 'center',
        align: 'center',
    },
  ]
  export const actionGroup =   [
    {
      name: '查看',
      flag:'details',
    }
  ]
  
  export const form_list = (addressOptions)=>{
    return  [
      {
        type: 'select',
        label: '企业类型',
        props: 'company_type',
        required: true,
        selectData: [
          {
            label: '人资公司',
            value: 1
          },
          {
            label: '用工企业',
            value: 2
          },
          {
            label: '高校',
            value: 3
          },
        ]
      },
      {
        type: 'input',
        label: '负责人名称',
        props: 'contact',
        required: true,
      },
      {
        type: 'input',
        label: '高校名称',
        props: 'company_name',
        required: true,
      },
      {
        type: 'input',
        label: '负责人电话',
        props: 'contact_phone',
        required: true,
      },
      {
        type: 'input',
        label: '企业税号',
        props: 'taxpayer',
        required: true,
      },
      {
        type: 'upload',
        label: '企业logo',
        props: 'logo',
        propsConfig:{
          type:'picture',
          dir:'xladmin/bill'
        }
      },
      {
        type: 'cascader',
        label: '高校地址',
        props: 'address_name',
        required: true,
        cascaderOption:addressOptions
      },
      {
        type: 'input',
        label: '详细地址',
        props: 'address_detail',
      },
       {
            type: 'upload',
            label: '附加材料',
            props: 'invoice_list',
            propsConfig: {
              type: 'picture-list',
              dir:'xladmin/bill',
              // draggable: true,
              limit: 3,
              accept: ["png", "jpg", "jpeg"],
              tip: '(PDF、OFD、图片、压缩包）',
              showFileList:false
            },
            // tip: '（最多1张，如有更多请上传压缩包）'
          },
    ] 
  
  }